import React from "react";

var betaSvg = function betaSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M5.5 2a1 1 0 1 1 0-2h5a1 1 0 0 1 0 2v2.544a6.001 6.001 0 1 1-5 0zm4.362 8c.83.268 1.542.268 2.138 0a4 4 0 0 0-2.334-3.638L8.5 5.827V2h-1v3.827l-1.166.535A4 4 0 0 0 4 10c.745-.655 1.583-.982 2.515-.982 1.397 0 2.071.57 3.347.982zM7 13a1 1 0 1 0 0-2 1 1 0 0 0 0 2z"
  }));
};

betaSvg.defaultProps = {
  height: "16",
  viewBox: "0 0 16 16",
  width: "16",
  xmlns: "http://www.w3.org/2000/svg"
};
export var beta = {
  category: 'icon',
  colorable: true,
  name: 'beta',
  svg: betaSvg
};